/**
 * Mock ADR for testing purposes
 */
export const mockADR = {
    "SalesOrderDetail": {
        "SoldToMemberID": "US00320640",
        "OrderID": "951434510",
        "ADROverrideNumber": "0228579790",
        "CountryCode": "US",
        "SalesOffice": "1015",
        "Date": 1519455600000,
        "Time": null,
        "DateCancelled": null,
        "DateReturned": null,
        "ProductDiscountCode": "",
        "ShippingDiscountCode": "",
        "OrderEntryUser": "WEBSRVUSER",
        "CommissionableInPriorMonth": false,
        "CommissionedInPriorMonth": false,
        "Reason": "ADR",
        "Channel": null,
        "Currency": "USD",
        "Status": "",
        "Type": null,
        "Category": null,
        "ExternalID": null,
        "GiftReciept": null,
        "LineItemDetails": [
            {
                "LineItem": {
                    "LineID": 40,
                    "ParentID": 0,
                    "SKU": "01003529",
                    "RequestedQuantity": 1,
                    "PromoCode": "",
                    "PayWithPoints": false,
                    "OneTime": false,
                    "Action": null,
                    "Category": null,
                    "Custom": null,
                    "Pricing": null
                },
                "ReplacedSKU": "",
                "Name": "Tegreen 120ct (US)",
                "AvailableQuantity": 1,
                "TotalAvailableQuantity": null,
                "Price": 57.5,
                "Points": 0,
                "FreightPromoSavings": 0,
                "ProductPromoSavings": 0,
                "Tax": 2.33,
                "TaxBase": 77.5,
                "PSV": 51.3,
                "CV": 52.59,
                "Freight": 0,
                "BackorderAvailableDate": null,
                "BackOrdered": false,
                "InvalidSku": false,
                "GrandFatheredPricing": false,
                "AddedBySystem": false
            },
            {
                "LineItem": {
                    "LineID": 50,
                    "ParentID": 0,
                    "SKU": "01111377",
                    "RequestedQuantity": 1,
                    "PromoCode": "",
                    "PayWithPoints": false,
                    "OneTime": false,
                    "Action": null,
                    "Category": null,
                    "Custom": null,
                    "Pricing": null
                },
                "ReplacedSKU": "",
                "Name": "AP-24 Toothbrush 3 pack (US)",
                "AvailableQuantity": 1,
                "TotalAvailableQuantity": null,
                "Price": 9.75,
                "Points": 0,
                "FreightPromoSavings": 0,
                "ProductPromoSavings": 0,
                "Tax": 0.84,
                "TaxBase": 12.25,
                "PSV": 7.6,
                "CV": 8.93,
                "Freight": 0,
                "BackorderAvailableDate": null,
                "BackOrdered": false,
                "InvalidSku": false,
                "GrandFatheredPricing": false,
                "AddedBySystem": false
            },
            {
                "LineItem": {
                    "LineID": 60,
                    "ParentID": 0,
                    "SKU": "01010271",
                    "RequestedQuantity": 1,
                    "PromoCode": "",
                    "PayWithPoints": false,
                    "OneTime": false,
                    "Action": null,
                    "Category": null,
                    "Custom": null,
                    "Pricing": null
                },
                "ReplacedSKU": "",
                "Name": "ADR ageLOC Youth & g3 (US)",
                "AvailableQuantity": 1,
                "TotalAvailableQuantity": null,
                "Price": 162.75,
                "Points": 0,
                "FreightPromoSavings": 0,
                "ProductPromoSavings": 0,
                "Tax": 6.14,
                "TaxBase": 204.75,
                "PSV": 140,
                "CV": 140,
                "Freight": 0,
                "BackorderAvailableDate": null,
                "BackOrdered": false,
                "InvalidSku": false,
                "GrandFatheredPricing": false,
                "AddedBySystem": false
            }
        ],
        "Payment": [
            {
                "id": "000001",
                "type": "CCARD",
                "amount": 0,
                "Currency": null,
                "action": null,
                "AuthorizationStatus": null,
                "DeclineMessage": null,
                "CreditCard": {
                    "Type": "VISA",
                    "CardNumber": "************0026",
                    "AuthorizationCode": "",
                    "Name": "Eleesha CommichauxQA Auto",
                    "ExpirationMonth": "12",
                    "ExpirationYear": "2020",
                    "PostalCode": "97250-1778",
                    "VerificationCode": "",
                    "EncryptedCardNumber": "AFBWlo2OHuiHxhI31nZ79Q==",
                    "TrackOne": "",
                    "Installments": null,
                    "TransactionType": {
                        "value": null,
                        "PaymentPeriod": 0
                    }
                },
                "Bank": null,
                "Custom": [
                    {
                        "Key": "LIMIT",
                        "Value": "239.31",
                        "Type": "AUTH"
                    },
                    {
                        "Key": "GUID",
                        "Value": "005056B10BE81EE886BE4017DA2E9EFB",
                        "Type": "PAYMENT"
                    },
                    {
                        "Key": "SORT_EXT",
                        "Value": "      100",
                        "Type": "PAYMENT"
                    }
                ],
                "Verification": null,
                "BillingAddress": null,
                "Messages": null,
                "AdditionalAuthorization": null
            }
        ],
        "Shipping": {
            "ShippingParty": [
                {
                    "ShippingMemberID": "US00320640",
                    "Type": "SOLD_TO",
                    "ShippingAddress": {
                        "ID": "US00320640",
                        "Name": "BOB, JIM",
                        "CareOfName": "",
                        "Address": {
                            "Street1": "557 S 700 E",
                            "Street2": "",
                            "City": "OREM",
                            "District": "",
                            "DistrictDesc": null,
                            "Region": "UT",
                            "RegionDesc": null,
                            "PostalCode": "84097-4417",
                            "CountryCode": "US",
                            "CountryCodeDesc": null,
                            "InternationalAddresses": null
                        },
                        "Contact": [
                            {
                                "Country": "",
                                "Value": {
                                    "value": "mchiang3@nuskin.com",
                                    "Type": "EMAIL"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "801-654-8484",
                                    "Type": "HOMEPHONE"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "801-654-8484",
                                    "Type": "MOBILEPHONE"
                                }
                            }
                        ],
                        "Instructions": ""
                    },
                    "Custom": [
                        {
                            "Key": "NAME_GIVEN",
                            "Value": "JIM",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "NAME_FAMILY",
                            "Value": "BOB",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "TAXJURCODE",
                            "Value": "USUT8409744170",
                            "Type": "PARTNER"
                        }
                    ]
                },
                {
                    "ShippingMemberID": "OPAS",
                    "Type": "SHIP_TO",
                    "ShippingAddress": {
                        "ID": "OPAS",
                        "Name": "Bill Bobby",
                        "CareOfName": "",
                        "Address": {
                            "Street1": "75 Center St",
                            "Street2": "",
                            "City": "Provo",
                            "District": "",
                            "DistrictDesc": null,
                            "Region": "UT",
                            "RegionDesc": null,
                            "PostalCode": "84604",
                            "CountryCode": "US",
                            "CountryCodeDesc": null,
                            "InternationalAddresses": null
                        },
                        "Contact": [
                            {
                                "Country": "",
                                "Value": {
                                    "value": "test@gmail.com",
                                    "Type": "EMAIL"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "801-123-1234",
                                    "Type": "HOMEPHONE"
                                }
                            }
                        ],
                        "Instructions": ""
                    },
                    "Custom": [
                        {
                            "Key": "NAME_GIVEN",
                            "Value": "",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "NAME_FAMILY",
                            "Value": "Bill Bobby",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "NAME_GIVEN_LOCAL",
                            "Value": "OPAS STE #",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "TAXJURCODE",
                            "Value": "USUT84604XXXX0",
                            "Type": "PARTNER"
                        }
                    ]
                },
                {
                    "ShippingMemberID": "US00320640",
                    "Type": "BILL_TO",
                    "ShippingAddress": {
                        "ID": "US00320640",
                        "Name": "BOB, JIM",
                        "CareOfName": "",
                        "Address": {
                            "Street1": "557 S 700 E",
                            "Street2": "",
                            "City": "OREM",
                            "District": "",
                            "DistrictDesc": null,
                            "Region": "UT",
                            "RegionDesc": null,
                            "PostalCode": "84097-4417",
                            "CountryCode": "US",
                            "CountryCodeDesc": null,
                            "InternationalAddresses": null
                        },
                        "Contact": [
                            {
                                "Country": "",
                                "Value": {
                                    "value": "mchiang3@nuskin.com",
                                    "Type": "EMAIL"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "801-654-8484",
                                    "Type": "HOMEPHONE"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "801-654-8484",
                                    "Type": "MOBILEPHONE"
                                }
                            }
                        ],
                        "Instructions": ""
                    },
                    "Custom": [
                        {
                            "Key": "NAME_GIVEN",
                            "Value": "JIM",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "NAME_FAMILY",
                            "Value": "BOB",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "TAXJURCODE",
                            "Value": "USUT8409744170",
                            "Type": "PARTNER"
                        }
                    ]
                },
                {
                    "ShippingMemberID": "US00320640",
                    "Type": "PAYER",
                    "ShippingAddress": {
                        "ID": "US00320640",
                        "Name": "BOB, JIM",
                        "CareOfName": "",
                        "Address": {
                            "Street1": "557 S 700 E",
                            "Street2": "",
                            "City": "OREM",
                            "District": "",
                            "DistrictDesc": null,
                            "Region": "UT",
                            "RegionDesc": null,
                            "PostalCode": "84097-4417",
                            "CountryCode": "US",
                            "CountryCodeDesc": null,
                            "InternationalAddresses": null
                        },
                        "Contact": [
                            {
                                "Country": "",
                                "Value": {
                                    "value": "mchiang3@nuskin.com",
                                    "Type": "EMAIL"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "801-654-8484",
                                    "Type": "HOMEPHONE"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "801-654-8484",
                                    "Type": "MOBILEPHONE"
                                }
                            }
                        ],
                        "Instructions": ""
                    },
                    "Custom": [
                        {
                            "Key": "NAME_GIVEN",
                            "Value": "JIM",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "NAME_FAMILY",
                            "Value": "BOB",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "TAXJURCODE",
                            "Value": "USUT8409744170",
                            "Type": "PARTNER"
                        }
                    ]
                },
                {
                    "ShippingMemberID": "US8128558",
                    "Type": "SPONSOR",
                    "ShippingAddress": {
                        "ID": "US8128558",
                        "Name": "My Business in the USA",
                        "CareOfName": "",
                        "Address": {
                            "Street1": "75 W CENTER ST",
                            "Street2": "address line 2",
                            "City": "PROVO",
                            "District": "county",
                            "DistrictDesc": null,
                            "Region": "UT",
                            "RegionDesc": null,
                            "PostalCode": "84601-4432",
                            "CountryCode": "US",
                            "CountryCodeDesc": null,
                            "InternationalAddresses": null
                        },
                        "Contact": [
                            {
                                "Country": "",
                                "Value": {
                                    "value": "customer3bpceanvlxz0@nuskin.com",
                                    "Type": "EMAIL"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "435-555-5557",
                                    "Type": "FAX"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "801-345-2200",
                                    "Type": "HOMEPHONE"
                                }
                            },
                            {
                                "Country": "",
                                "Value": {
                                    "value": "888-888-8882",
                                    "Type": "MOBILEPHONE"
                                }
                            }
                        ],
                        "Instructions": ""
                    },
                    "Custom": [
                        {
                            "Key": "NAME_GIVEN",
                            "Value": "",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "NAME_FAMILY",
                            "Value": "My Business in the USA",
                            "Type": "PARTNER"
                        },
                        {
                            "Key": "TAXJURCODE",
                            "Value": "USUT8460144320",
                            "Type": "PARTNER"
                        }
                    ]
                }
            ],
            "ShippingMethod": {
                "Code": "EC",
                "Default": null,
                "Description": "Standard",
                "Cost": 0,
                "PickUpLocation": "",
                "Currency": null
            },
            "Tracking": null
        },
        "ShippingAvailableMethods": [
            {
                "Code": "EO",
                "Default": null,
                "Description": "One Day Air",
                "Cost": 35,
                "PickUpLocation": "",
                "Currency": null
            },
            {
                "Code": "EP",
                "Default": null,
                "Description": "Express",
                "Cost": 12,
                "PickUpLocation": "",
                "Currency": null
            },
            {
                "Code": "ES",
                "Default": null,
                "Description": "One Day Air Saturday",
                "Cost": 45,
                "PickUpLocation": "",
                "Currency": null
            },
            {
                "Code": "PS",
                "Default": null,
                "Description": "USPS - US Mail",
                "Cost": 8,
                "PickUpLocation": "",
                "Currency": null
            },
            {
                "Code": "EC",
                "Default": null,
                "Description": "Standard",
                "Cost": 8,
                "PickUpLocation": "",
                "Currency": null
            }
        ],
        "SerialNumber": null,
        "OrderTotals": {
            "GrandTotal": 239.31,
            "ItemSubtotal": 230,
            "Tax": 9.31,
            "TaxBase": 294.5,
            "Savings": 0,
            "Shipping": 0,
            "PSV": 198.9,
            "CV": 201.52,
            "Rounding": 0,
            "TaxInclusive": null,
            "Custom": null
        },
        "Custom": [
            {
                "Key": "ZZPRICED_PACK_SL",
                "Value": "",
                "Type": ""
            },
            {
                "Key": "ZZPRIMARY",
                "Value": "X",
                "Type": ""
            },
            {
                "Key": "SENDER",
                "Value": "Johnny Bravo",
                "Type": "SHIP"
            }
        ],
        "Pricing": null
    },
    "ShipToName": null,
    "Editable": true,
    "CreateDate": 1519455600000,
    "EndDate": null,
    "NextDeliveryDate": 1521871200000,
    "LastPlacedDate": 1519455600000,
    "ContractLength": 0,
    "OrderFrequency": 1,
    "LastOrderStatus": "",
    "TimeStamp": "                         20180308192556",
    "Overridden": false,
    "Held": false,
    "Scan": [
        {
            "ScanNumber": "0000000000012345",
            "ADRNumber": "951434510",
            "Label": "test12345",
            "Active": true,
            "Action": null
        }
    ],
    "Custom": null,
    "MonthCount": 0
};
